import React from "react";
import { useState } from "react";

import imageOne from "../../../assets/lesson 10.1.png";
import imageTwo from "../../../assets/lesson 5.2.png";

function LessonTen() {
  const [q1, setQ1] = useState("");
  const [q2, setQ2] = useState("");
  const [q3, setQ3] = useState("");
  const [q4, setQ4] = useState("");
  const [q5, setQ5] = useState("");
  const [q6, setQ6] = useState("");
  const [q7, setQ7] = useState("");
  const [q8, setQ8] = useState("");
  const [q9, setQ9] = useState("");
  const [q10, setQ10] = useState("");
  const [q11, setQ11] = useState("");
  const [q12, setQ12] = useState("");
  const [q13, setQ13] = useState("");
  const [q14, setQ14] = useState("");
  const [q15, setQ15] = useState("");
  const [q16, setQ16] = useState("");
  const [q17, setQ17] = useState("");
  const [q18, setQ18] = useState("");
  const [q19, setQ19] = useState("");
  const [q20, setQ20] = useState("");
  const [q21, setQ21] = useState("");
  const [q22, setQ22] = useState("");
  const [q23, setQ23] = useState("");
  const [q24, setQ24] = useState("");
  const [q25, setQ25] = useState("");
  const [q26, setQ26] = useState("");
  const [q27, setQ27] = useState("");
  const [q28, setQ28] = useState("");
  const [q29, setQ29] = useState("");
  const [q30, setQ30] = useState("");
  const [q31, setQ31] = useState("");
  const [q32, setQ32] = useState("");
  const [q33, setQ33] = useState("");
  const [q34, setQ34] = useState("");
  const [q35, setQ35] = useState("");
  const [q36, setQ36] = useState("");
  const [q37, setQ37] = useState("");
  const [q38, setQ38] = useState("");
  const [q39, setQ39] = useState("");
  const [q40, setQ40] = useState("");
  return (
    <>
      <div className="">
        <div className="task-one mb-3">
          <h4>
            <span>10.1</span> Write these sentences with <strong> got </strong>.
            The meaning is the same.
          </h4>
          <p className="table row">
            <ol className="">
              <li>
                They have two children.
                <input
                  className="border"
                  value="They've got two children."
                  disabled
                  style={{ background: "#198754", color: "white" }}
                />
              </li>
              <li>
                She doesn't have a key.
                <input
                  className="border"
                  value="She hasn't got a key."
                  disabled
                  style={{ background: "#198754", color: "white" }}
                />
              </li>
              <li>
                He has a new job. He
                <input
                  className="border"
                  onChange={(e) => setQ1(e.target.value)}
                  style={{
                    background:
                      q1.trim() === "has got a new job."
                        ? "#198754"
                        : q1.trim() === "'s got a new job."
                        ? "#198754"
                        : "white",
                    color:
                      q1.trim() === "has got a new job."
                        ? "white"
                        : q1.trim() === "'s got a new job."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                Do you have an umbrella?
                <input
                  className="border"
                  onChange={(e) => setQ2(e.target.value)}
                  style={{
                    background:
                      q2.trim() === "Have you got an umbrella?"
                        ? "#198754"
                        : "white",
                    color:
                      q2.trim() === "Have you got an umbrella?"
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                We have a lot of work to do.
                <input
                  className="border"
                  onChange={(e) => setQ3(e.target.value)}
                  style={{
                    background:
                      q3.trim() === "We have got a lot of work to do."
                        ? "#198754"
                        : q3.trim() === "We've got a lot of work to do."
                        ? "#198754"
                        : "white",
                    color:
                      q3.trim() === "We have got a lot of work to do."
                        ? "white"
                        : q3.trim() === "We've got a lot of work to do."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                I don't have your phone number.
                <input
                  className="border"
                  onChange={(e) => setQ4(e.target.value)}
                  style={{
                    background:
                      q4.trim() === "I haven't got your phone number."
                        ? "#198754"
                        : "white",
                    color:
                      q4.trim() === "I haven't got your phone number."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                Does your father have a car?
                <input
                  className="border"
                  onChange={(e) => setQ5(e.target.value)}
                  style={{
                    background:
                      q5.trim() === "Has your father got a car?"
                        ? "#198754"
                        : "white",
                    color:
                      q5.trim() === "Has your father got a car?"
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                How much money do we have?
                <input
                  className="border"
                  onChange={(e) => setQ6(e.target.value)}
                  style={{
                    background:
                      q6.trim() === "How much money have we got?"
                        ? "#198754"
                        : "white",
                    color:
                      q6.trim() === "How much money have we got?"
                        ? "white"
                        : "black",
                  }}
                />
              </li>
            </ol>
          </p>
        </div>

        <hr />

        <div className="task-two mb-3">
          <h4>
            <span>10.2</span> Write these sentences with
            <strong> do / does /don't / doesn't.</strong> The meaning is the
            same.
          </h4>
          <p className="table row">
            <ol className="">
              <li>
                Have you got any money?
                <input
                  className="border"
                  value="Do you have any money?"
                  disabled
                  style={{
                    background: "#198754",
                    color: "white",
                  }}
                />
              </li>
              <li>
                I haven't got many clothes. I
                <input
                  className="border"
                  onChange={(e) => setQ7(e.target.value)}
                  style={{
                    background:
                      q7.trim() === "don't have many clothes."
                        ? "#198754"
                        : "white",
                    color:
                      q7.trim() === "don't have many clothes."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                Has Tom got a brother?
                <input
                  className="border"
                  onChange={(e) => setQ8(e.target.value)}
                  style={{
                    background:
                      q8.trim() === "Does Tom have a brother?"
                        ? "#198754"
                        : "white",
                    color:
                      q8.trim() === "Does Tom have a brother?"
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                How many children have they got?
                <input
                  className="border"
                  onChange={(e) => setQ9(e.target.value)}
                  style={{
                    background:
                      q9.trim() === "How many children do they have?"
                        ? "#198754"
                        : "white",
                    color:
                      q9.trim() === "How many children do they have?"
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                Have you got any questions?
                <input
                  className="border"
                  onChange={(e) => setQ10(e.target.value)}
                  style={{
                    background:
                      q10.trim() === "Do you have any questions?"
                        ? "#198754"
                        : "white",
                    color:
                      q10.trim() === "Do you have any questions?"
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                Sam hasn't got a job.
                <input
                  className="border"
                  onChange={(e) => setQ11(e.target.value)}
                  style={{
                    background:
                      q11.trim() === "Sam doesn't have a job."
                        ? "#198754"
                        : "white",
                    color:
                      q11.trim() === "Sam doesn't have a job."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
            </ol>
          </p>
        </div>

        <hr />

        <div className="task-three mb-3 row ">
          <h4>
            <span>10.3</span> Read the questions and answers. Then write
            sentences about Mark.
          </h4>
          <p className="table row">
            <img
              src={imageOne}
              alt=""
              className="col-xsm-12 col-sm-12 col-md-8 col-lg-7 col-xlg-7"
            />

            <ol className="col-xsm-12 col-sm-12 col-md-4 col-lg-5 col-xlg-5 ">
              <li>
                <input
                  className="border"
                  value="He hasn't got a car."
                  disabled
                  style={{
                    background: "#198754",
                    color: "white",
                  }}
                />
              </li>
              <li>
                He
                <input
                  className="border"
                  onChange={(e) => setQ12(e.target.value)}
                  style={{
                    background:
                      q12.trim() === "has got a bike."
                        ? "#198754"
                        : q12.trim() === "has a bike."
                        ? "#198754"
                        : q12.trim() === "'s got a bike."
                        ? "#198754"
                        : "white",
                    color:
                      q12.trim() === "has got a bike."
                        ? "white"
                        : q12.trim() === "has a bike."
                        ? "white"
                        : q12.trim() === "'s got a bike."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                <input
                  className="border"
                  onChange={(e) => setQ13(e.target.value)}
                  style={{
                    background:
                      q13.trim() === "He hasn't got a dog."
                        ? "#198754"
                        : q13.trim() === "He doesn't have a dog."
                        ? "#198754"
                        : "white",
                    color:
                      q13.trim() === "He hasn't got a dog."
                        ? "white"
                        : q13.trim() === "He doesn't have a dog."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                <input
                  className="border"
                  onChange={(e) => setQ14(e.target.value)}
                  style={{
                    background:
                      q14.trim() === "He has a mobile phone."
                        ? "#198754"
                        : q14.trim() === "He has got a mobile phone."
                        ? "#198754"
                        : q14.trim() === "He's got a mobile phone."
                        ? "#198754"
                        : "white",
                    color:
                      q14.trim() === "He has a mobile phone."
                        ? "white"
                        : q14.trim() === "He has got a mobile phone."
                        ? "white"
                        : q14.trim() === "He's got a mobile phone."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                <input
                  className="border"
                  onChange={(e) => setQ15(e.target.value)}
                  style={{
                    background:
                      q15.trim() === "He hasn't got a watch."
                        ? "#198754"
                        : q15.trim() === "He doesn't have a watch."
                        ? "#198754"
                        : "white",
                    color:
                      q15.trim() === "He hasn't got a watch."
                        ? "white"
                        : q15.trim() === "He doesn't have a watch."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                <input
                  className="border"
                  onChange={(e) => setQ16(e.target.value)}
                  style={{
                    background:
                      q16.trim() === "He has got two brothers and a sister."
                        ? "#198754"
                        : q16.trim() === "He has two brothers and a sister."
                        ? "#198754"
                        : q16.trim() === "He's got two brothers and a sister."
                        ? "#198754"
                        : "white",
                    color:
                      q16.trim() === "He has got two brothers and a sister."
                        ? "white"
                        : q16.trim() === "He has two brothers and a sister."
                        ? "white"
                        : q16.trim() === "He's got two brothers and a sister."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
            </ol>
          </p>
        </div>

        <hr />

        <div className="task-four mb-3">
          <h4>
            <span>10.4</span> Complete the sentences. Use
            <strong> Have, has, don't have</strong> or
            <strong> doesn't have.</strong>
          </h4>
          <p className="table row">
            <ol className="border">
              <li>
                Sarah
                <input
                  className="border"
                  value="doesn't have"
                  disabled
                  style={{ background: "#198754", color: "white" }}
                />
                a car. She goes everywhere by bike.
              </li>
              <li>
                They like animals. They
                <input
                  className="border"
                  value="have"
                  disabled
                  style={{ background: "#198754", color: "white" }}
                />
                Three dogs and two cats.
              </li>
              <li>
                Charles isn't happy. He
                <input
                  className="border"
                  onChange={(e) => setQ17(e.target.value)}
                  style={{
                    background: q17.trim() === "has" ? "#198754" : "white",
                    color: q17.trim() === "has" ? "white" : "black",
                  }}
                />
                a lot of problems.
              </li>
              <li>
                They are always busy. They
                <input
                  className="border"
                  onChange={(e) => setQ18(e.target.value)}
                  style={{
                    background:
                      q18.trim() === "don't have" ? "#198754" : "white",
                    color: q18.trim() === "don't have" ? "white" : "black",
                  }}
                />
                much free time.
              </li>
              <li>
                'What's wrong' 'I
                <input
                  className="border"
                  onChange={(e) => setQ19(e.target.value)}
                  style={{
                    background: q19.trim() === "have" ? "#198754" : "white",
                    color: q19.trim() === "have" ? "white" : "black",
                  }}
                />
                something in my eye.'
              </li>
              <li>
                'Where's my pen?' 'I don't know. I
                <input
                  className="border"
                  onChange={(e) => setQ20(e.target.value)}
                  style={{
                    background:
                      q20.trim() === "don't have" ? "#198754" : "white",
                    color: q20.trim() === "don't have" ? "white" : "black",
                  }}
                />
                it.'
              </li>
              <li>
                Amy wants to go to the concert, but she
                <input
                  className="border"
                  onChange={(e) => setQ21(e.target.value)}
                  style={{
                    background:
                      q21.trim() === "doesn't have" ? "#198754" : "white",
                    color: q21.trim() === "doesn't have" ? "white" : "black",
                  }}
                />
                a ticket.
              </li>
            </ol>
          </p>
        </div>

        <hr />

        <div className="task-five mb-3">
          <h4>
            <span>10.5</span> Complete the sentences. Use
            <strong> Have got, has got, haven't got or hasn't got</strong> with:
          </h4>
          <p className="table row">
            <ul className="border d-flex justify-content-evenly">
              <li>six legs</li>
              <li>a key</li>
              <li className="strike">a headache</li>
              <li>a lot of friends</li>
              <li>a job</li>
              <li>much time</li>
            </ul>
            <ol className="">
              <li>
                I'm not feeling very well. I
                <input
                  className="border"
                  value="'ve got a headache."
                  disabled
                  style={{ background: "#198754", color: "white" }}
                />
              </li>

              <li>
                Everybody likes Tom. He
                <input
                  className="border"
                  onChange={(e) => setQ22(e.target.value)}
                  style={{
                    background:
                      q22.trim() === "has a lot of friends."
                        ? "#198754"
                        : "white",
                    color:
                      q22.trim() === "has a lot of friends."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                She can't open the door. She
                <input
                  className="border"
                  onChange={(e) => setQ23(e.target.value)}
                  style={{
                    background:
                      q23.trim() === "doesn't have a key."
                        ? "#198754"
                        : "white",
                    color:
                      q23.trim() === "doesn't have a key." ? "white" : "black",
                  }}
                />
              </li>
              <li>
                Quick!. We
                <input
                  className="border"
                  onChange={(e) => setQ24(e.target.value)}
                  style={{
                    background:
                      q24.trim() === "don't have much time."
                        ? "#198754"
                        : "white",
                    color:
                      q24.trim() === "don't have much time."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                An insect
                <input
                  className="border"
                  onChange={(e) => setQ25(e.target.value)}
                  style={{
                    background:
                      q25.trim() === "has six legs." ? "#198754" : "white",
                    color: q25.trim() === "has six legs." ? "white" : "black",
                  }}
                />
              </li>
              <li>
                I'm unemployed. I
                <input
                  className="border"
                  onChange={(e) => setQ26(e.target.value)}
                  style={{
                    background:
                      q26.trim() === "don't have a job." ? "#198754" : "white",
                    color:
                      q26.trim() === "don't have a job." ? "white" : "black",
                  }}
                />
              </li>
            </ol>
          </p>
        </div>
      </div>
    </>
  );
}

export default LessonTen;
